import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import React, { useMemo } from 'react'
import { View } from 'react-native'
import { NavigationBarAccessory } from '@src/components'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Icon } from '@src/components/base'
import { AppStackParamList } from '@src/navigation/types'
import { NavigationContainer } from '@src/screens/Common/containers'
import { useApplicationActionSheet } from '@src/hooks/useApplicationActionSheet'

enum BiomarkersDataActionSheetOption {
  Date = 'Date',
  Biomarker = 'Biomarker',
}

export interface LabResultsNavigationContainerProps {
  children: React.ReactNode
  screen: 'BiomarkersScreen' | 'LabResultsScreen'
}

export const LabResultsNavigationContainer = ({
  children,
  screen,
}: LabResultsNavigationContainerProps) => {
  const navigation = useNavigation<StackNavigationProp<AppStackParamList>>()
  const styles = useStyleSheet(themedStyles)
  const { showActionSheet } = useApplicationActionSheet<BiomarkersDataActionSheetOption>()

  const rightAccessories = useMemo(() => {
    const dateAction = () =>
      screen === 'BiomarkersScreen' ? navigation.replace('LabResultsScreen') : undefined
    const biomarkerAction = () =>
      screen === 'LabResultsScreen' ? navigation.replace('BiomarkersScreen') : undefined

    const onGroupByPress = () => {
      showActionSheet({
        title: 'Group by',
        options: [BiomarkersDataActionSheetOption.Date, BiomarkersDataActionSheetOption.Biomarker],
        callback: (option: BiomarkersDataActionSheetOption) => {
          switch (option) {
            case BiomarkersDataActionSheetOption.Date:
              dateAction()
              break
            case BiomarkersDataActionSheetOption.Biomarker:
              biomarkerAction()
              break
          }
        },
      })
    }

    return [
      {
        renderIconComponent: () => (
          <View style={styles.groupByIcon}>
            <Icon name="arrows-down-up" />
          </View>
        ),
        onPress: onGroupByPress,
        accessibilityLabel: 'View past lab results',
      },
    ] as NavigationBarAccessory[]
  }, [navigation, screen, showActionSheet, styles.groupByIcon])

  return (
    <NavigationContainer title="Lab Results" rightAccessories={rightAccessories}>
      {children}
    </NavigationContainer>
  )
}

const themedStyles = StyleService.create({
  groupByIcon: {
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 16,
    height: 44,
  },
})
